(ns ui.components.modal.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Modal/styles.json
;; Source commit: ccb1b7a183f2b627ab3349bd90696979139e4413
;; ----------------------------------------------------------------------------

(def modal
  {:overlay
   {:base
    "tw2-fixed tw2-inset-0 tw2-bg-modal-bg-overlay tw2-opacity-modal-overlay tw2-z-modal-overlay-backdrop tw2-transition-opacity tw2-duration-200",
    :visible "tw2-opacity-100",
    :hidden "tw2-opacity-0"},
   :panel
   {:base
    "tw2-fixed tw2-top-1/2 tw2-left-1/2 tw2-transform tw2-flex tw2-flex-col tw2-max-h-modal-max-height tw2-py-modal-padding-vertical tw2-gap-modal-gap tw2-bg-modal-bg-content tw2-rounded-overlay tw2-shadow-modal tw2-z-modal-overlay tw2-text-primary tw2-transition-all tw2-duration-200 tw2-ease-out tw2--translate-x-1/2",
    :size
    {:sm
     "tw2-w-modal-sm tw2-max-w-[min(var(--modal-sm),calc(100vw-2rem))]",
     :md
     "tw2-w-modal-md tw2-max-w-[min(var(--modal-md),calc(100vw-2rem))]",
     :lg
     "tw2-w-modal-lg tw2-max-w-[min(var(--modal-lg),calc(100vw-2rem))]",
     :xl
     "tw2-w-modal-xl tw2-max-w-[min(var(--modal-xl),calc(100vw-2rem))]"},
    :visible "tw2-opacity-100 tw2-scale-100 tw2--translate-y-1/2",
    :hidden
    "tw2-opacity-0 tw2-scale-95 tw2--translate-y-[calc(50%-1rem)]"},
   :header
   {:base
    "tw2-flex tw2-flex-col tw2-flex-shrink-0 tw2-px-modal-padding-horizontal tw2-relative tw2-z-10",
    :row "tw2-flex tw2-items-center tw2-justify-between tw2-w-full",
    :title "tw2-text-heading-sm tw2-text-primary tw2-flex-1"},
   :helper-text {:base "tw2-text-body-md tw2-text-tertiary tw2-w-full"},
   :content
   {:base
    "tw2-overflow-y-auto tw2-flex tw2-flex-col tw2-flex-1 tw2-px-modal-padding-horizontal tw2-text-primary"},
   :footer
   {:base
    "tw2-flex tw2-items-center tw2-justify-between tw2-flex-shrink-0 tw2-px-modal-padding-horizontal tw2-relative tw2-z-10 tw2-text-primary"}})
